const attributes: Record<string, string> = {};

function noticeInteraction(id, params) {
  // We don't normally call Jigsaw like this, but it's a better fit for
  // patterns here, where noticeInteraction is directly imported. We
  // can't get good access to dispatch from here
  if (window.Jigsaw) {
    window.Jigsaw.Events.logEvent({
      name: id,
      json: params,
      vbid: attributes.vbid,
    });
  }
}

function setAttribute(key, value) {
  attributes[key] = value;
}

function unsetAttribute(key) {
  delete attributes[key];
}

const api = {
  noticeInteraction,
  setAttribute,
  unsetAttribute,
};
export default api;
